<template>
  <footer>
    <div class="content-wrap">
      <span class="copyright">© HiLite Sports</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: []
};
</script>

<style lang="stylus" scoped>
footer
  background: #1E234D
  width: 100%
  height: 60px
  position: absolute
  bottom: 0px
  .content-wrap
    full-width-content()
    height: 60px
    display: flex
    align-items: center
    .copyright
      color: #FFFFFF
      margin-left: auto
</style>
